var map = {
	"./background-festival-atmosphere.png": 3551,
	"./background-festival.png": 4640,
	"./background1.jpg": 3752,
	"./background1.png": 3212,
	"./background10.jpg": 3810,
	"./background12.jpg": 2576,
	"./background2.jpg": 2423,
	"./background2.png": 3895,
	"./background20.jpg": 2519,
	"./background21.jpg": 8058,
	"./background3.jpg": 4138,
	"./background30.jpg": 6808,
	"./background31.jpg": 4677,
	"./background32.jpg": 8426,
	"./background4.jpg": 9977,
	"./background6.jpg": 8635,
	"./background6.png": 2611,
	"./background7.jpg": 8478,
	"./background7.png": 2778,
	"./obozy-5.png": 2386,
	"./obozy-6.png": 7001,
	"./obozy-7.png": 8880,
	"./obozy-8.png": 9975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7413;